/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MemoirsInputs */

const en_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memoirs`)
};

const es_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memorias`)
};

const fr_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mémoires`)
};

const de_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memoiren`)
};

const ja_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回想録`)
};

const zh_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回忆录`)
};

const ar_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مذكرات`)
};

const id_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memoar`)
};

const it_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memorie`)
};

const ru_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мемуары`)
};

const pt_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memórias`)
};

const ko_memoirs = /** @type {(inputs: MemoirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회고록`)
};

/**
* | output |
* | --- |
* | "Memoirs" |
*
* @param {MemoirsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const memoirs = /** @type {((inputs?: MemoirsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MemoirsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_memoirs(inputs)
	if (locale === "es") return es_memoirs(inputs)
	if (locale === "fr") return fr_memoirs(inputs)
	if (locale === "de") return de_memoirs(inputs)
	if (locale === "ja") return ja_memoirs(inputs)
	if (locale === "zh") return zh_memoirs(inputs)
	if (locale === "ar") return ar_memoirs(inputs)
	if (locale === "id") return id_memoirs(inputs)
	if (locale === "it") return it_memoirs(inputs)
	if (locale === "ru") return ru_memoirs(inputs)
	if (locale === "pt") return pt_memoirs(inputs)
	return ko_memoirs(inputs)
});